import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
const Tick = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    fill='none'
    {...props}
  >
    <Path
      fill='#C0A46F'
      d='M7.971 14.346 3.92 10.295l.554-.554 3.497 3.506 7.563-7.563.546.553-8.109 8.11Z'
    />
  </Svg>
);
export default Tick;